<template>
  <v-dialog max-width="250px" v-model="dialog" @keydown.enter.prevent="close">
    <v-card>
      <v-card-title>
        <span class="headline"/>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-text-field :label="labelFrom" v-model.number="value.lower" hide-details/>
          <v-text-field :label="labelTo" v-model.number="value.upper" hide-details/>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <v-text-field v-model.trim="text" :label="label" readonly v-on="on" hide-details/>
    </template>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {Range} from '../../models/utils/Range'

export default {
  name: "r-range",
  props: {
    model: VueTypes.instanceOf(Range),
    label: VueTypes.string.def("Range"),
    labelFrom: VueTypes.string.def("Lower bound:"),
    labelTo: VueTypes.string.def("Upper bound:"),
  },
  data: () => ({
    dialog: false,
    text: null
  }),
  methods: {
    checkChange() {
      this.text = this.value.string;
    },
    close() {
      if (this.model.empty() || this.model.valid()) {
        this.dialog = false;
      }
    }
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new Range();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  mounted() {
    this.checkChange()
  },
  watch: {
    dialog() {
      this.checkChange();
    },
    value() {
      this.checkChange();
    }
  }
}
</script>